import React from 'react';
import { TouchableOpacity, StyleSheet, View } from 'react-native';
import { CommonProperties } from '../../styles';
import Icon from '../Icon';
import BaseText from '../BaseText';
import { scale } from '../../utils/scale.utils';

const ExpenseOption = ({ name, iconName, style, onPress }) => {
  return (
    <TouchableOpacity onPress={onPress}>
      <View style={[styles.item, style]}>
        <Icon name={iconName} size={24} color="white" />
        <BaseText style={styles.icon}>{name}</BaseText>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  item: {
    flex: 1,
    ...CommonProperties.px3,
    ...CommonProperties.centerAlignment,
    width: scale(56),
  },
  icon: {
    color: 'white',
    ...CommonProperties.pt3,
  },
});

export default ExpenseOption;
